








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'stopper-component',
})
export default class StopperComponent extends Vue {
  @Prop({ default: '' })
  protected stopper: string | undefined;
}
